import { Api } from '@sodamnfoolish/sjc-backend-types';
import { useContext } from 'react';
import { LiveDataPumpTokensContext } from './LiveDataPumpTokensProvider';
import { LiveDataBonkTokensContext } from './LiveDataBonkTokensProvider';

export function LiveDataToken<T extends Api.Pump.DTO.PumpFunToken | Api.Bonk.DTO.LetsBonkToken>(props: {
    token: T;
    ctx: DeriveContext<T>;
    children: (token: T) => JSX.Element;
}) {
    const latestTokens = useContext(props.ctx as typeof LiveDataPumpTokensContext & typeof LiveDataBonkTokensContext);
    const token = props.token;

    const updated = latestTokens?.[token.mint]
        ? {
              ...token,
              ...latestTokens[token.mint],
          }
        : token;

    return props.children(updated);
}

export type DeriveContext<R extends Api.Pump.DTO.PumpFunToken | Api.Bonk.DTO.LetsBonkToken> = R extends Api.Pump.DTO.PumpFunToken
    ? typeof LiveDataPumpTokensContext
    : typeof LiveDataBonkTokensContext;
